import React, { FC } from 'react';
import Component, { Icon } from './styles';
import { Props } from './types';

const AddButton: FC<Props> = ({ children, onClick, size, ...props }) => {
  return (
    <Component onClick={onClick} $size={size} {...props}>
      <Icon />
      {children}
    </Component>
  );
};

export default AddButton;
